import { render, staticRenderFns } from "./Kgl.vue?vue&type=template&id=5397f63f&scoped=true&"
import script from "./Kgl.vue?vue&type=script&lang=js&"
export * from "./Kgl.vue?vue&type=script&lang=js&"
import style0 from "./Kgl.vue?vue&type=style&index=0&id=5397f63f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5397f63f",
  null
  
)

export default component.exports